export * from './iris-settings.dialog.component';
